import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import Button from '@/ui-kit/components/Button/Button';
import { DataList, DataListItem, DataListLabel, DataListValue } from '@/ui-kit/components/DataList/DataList';

type Props = ModalProps<{ monthlyCost: number }>;

const IdProtectSignupSuccess = ({ payload, closeModal }: Props) => {
  const { t } = useTranslation(['Modal', 'Common']);

  return (
    <Modal title={t('IdProtectSignupSuccess.title')}>
      <p>{t('IdProtectSignupSuccess.body')}</p>
      <DataList>
        <DataListItem>
          <DataListLabel>{t('IdProtectSignupSuccess.monthlyCost')}</DataListLabel>
          <DataListValue>{t('Common:money', { amount: payload.monthlyCost })}</DataListValue>
        </DataListItem>
      </DataList>

      <ModalActions>
        <Button onClick={closeModal}>{t('IdProtectSignupSuccess.button')}</Button>
      </ModalActions>
    </Modal>
  );
};

export default IdProtectSignupSuccess;
